
<section class="content">
    <section>
        <div class="row">
            <div class="box  box-primary" *ngIf="inventoryControlFlag">
                 <PartsInventory #parts></PartsInventory>
            </div>
            <div class="box  box-primary" style="text-align: center;padding-top: 20px;" *ngIf="!inventoryControlFlag">
                <label style="color: red;">No Permission for Add/Edit/View this page.</label>
            </div>
        </div>
    </section>
</section>
